<div class="formControl">
  <ng-select2 [options]="options" width="100%" (valueChanged)="valueChanged($event)" id="customers-filter">
  </ng-select2>
</div>
